function slider () {
    /*
    Benefits slider
    */
    const benefitsSlider = document.querySelector('.slider-benefits');
    
    if(benefitsSlider) {
        let slider = new Swiper(benefitsSlider, {
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: ".slider-benefits__btn--next",
                prevEl: ".slider-benefits__btn--prev",
            },
            breakpoints: {
                1: {
                  slidesPerView: 3,
                },
                1261: {
                  slidesPerView: 4,
                }
            }
        });
    }


    /*
    Team slider
    */
    const teamSlider = document.querySelector('.slider-team');

    if(teamSlider) {
        let slider = new Swiper(teamSlider, {
            loop: true,
            spaceBetween: 40,
            navigation: {
                nextEl: ".slider-team__nav--next",
                prevEl: ".slider-team__nav--prev",
            },
            breakpoints: {
                1: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                }
            }
            // pagination: {
            //   el: ".swiper-pagination",
            //   clickable: true,
            // },
        });
    }


    /*=======
    Welcome slider
    =======*/
    const welcomeSlider = document.querySelector('.welcome__news-slider');

    if(welcomeSlider) {
        let slider = new Swiper(welcomeSlider, {
            speed: 600,
            spaceBetween: 20,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                1: {
                  slidesPerView: 1,
                  loop: true,
                },
                768: {
                  slidesPerView: 3,
                  loop: false,
                },
            },
            pagination: {
                el: ".welcome__news-pagination",
                clickable: true,
            },
        });
    }
}

export default slider;